module.exports = __webpack_public_path__ + "img/content8.a7d89fe1.png";